export function getAccountTypeKey(cognitoId: string) {
  return `${cognitoId}:accountType`;
}
